import React, { Component } from "react";
import { Redirect, Link } from 'react-router-dom';
import ReactFullpage from '@fullpage/react-fullpage';
import { FacebookProvider, Page } from 'react-facebook';
import { BrowserView, MobileView, isBrowser, isMobile, isSafari } from 'react-device-detect';
import { browserName, CustomView } from 'react-device-detect';
import styles from '../../assets/scss/modules/landing.module.scss';
import twitter from "../../assets/media/images/Responziv/Twitter.png";
import tiktok from "../../assets/media/images/Responziv/Tiktok.png";
import instagram from "../../assets/media/images/Responziv/Instagram.png";
import facebook from "../../assets/media/images/Responziv/Facebook.png";
import jogasz from "../../assets/media/images/Responziv/jogasz.png";
import kepviselo from "../../assets/media/images/Responziv/kepviselo.png";
import csalad from "../../assets/media/images/Responziv/csalad.png";
import asset1 from "../../assets/media/images/Responziv/asset1.png";
import asset2 from "../../assets/media/images/Responziv/asset2.png";
import asset3 from "../../assets/media/images/Responziv/asset3.png";
import asset4 from "../../assets/media/images/Responziv/asset4.png";
import erikfoto from "../../assets/media/images/Responziv/Erik-foto.png";
import FooterResponziv from "../Footer/FooterResponziv";



import{
	MDBContainer,
	MDBRow,
	MDBCol,
	MDBCard,
	MDBCardHeader,
	MDBCardBody,
  MDBBtn,
} from 'mdbreact';

class LandingPageResponziv extends Component {

  render() {
    return (
			<>
				<MDBContainer fluid className="fluid-container">
					<div className={styles.bodywrapper}>
						<MDBRow className="m-0 pb-5">
							<MDBCol size="12" className="text-center">
								<img className="erik-foto-respo" src={erikfoto}></img>
								<img className="asset3-size-respo" src={asset3}></img>
								<img className="asset4-size-respo" src={asset4}></img>
							</MDBCol>
						</MDBRow>
						<MDBRow className="m-0">
              <MDBCol size="12" className="col-csatlakozom-respo text-center">
								<a 	href="https://actionnetwork.org/forms/legyel-a-dk-aktivistaja/?fbclid=IwAR3BHfOSTA7n7UMN6HVcdgxwGGa5aT28mNVoIVowEcldfOzsbVwOYSpwk-o"
										target="_blank" rel="noopener noreferrer">
										<MDBBtn
												className="csatlakozom-btn-landing"
												type="btn"
												>
												CSATLAKOZZ!
										</MDBBtn>
								</a>
							</MDBCol>
						</MDBRow>
						<MDBRow className="m-0 p-0">
              <MDBCol size="12" className="col-csatlakozom-respo-2 text-center">
							
							</MDBCol>
						</MDBRow>
              <MDBContainer className="padding-container">
                <MDBRow center className="m-0">
                  <MDBCol size="4" className="text-right pt-2 px-0">
										<Link to="/ProgramokBaj">
											<span className="baj">BAJ</span>
										</Link>
                  </MDBCol>
                  <MDBCol size="4" className="text-center pt-2 px-0">
										<Link to="/ProgramokSzarliget">
											<span className="szarliget">SZÁRLIGET</span>
										</Link>
                  </MDBCol>
                  <MDBCol size="4" className="text-left pt-2 px-0">
										<Link to="/ProgramokTata">
											<span className="tata">TATA</span>
										</Link>
                  </MDBCol>
                  <MDBCol size="6" className="text-right pr-4 pt-3">
										<Link to="/ProgramokTatabanya">
											<span className="tatabanya">TATABÁNYA</span>
										</Link>
                  </MDBCol>
                  <MDBCol size="6" className="text-left pt-3">
										<Link to="/ProgramokVertesszolos">
											<span className="vertesszolos">VÉRTESSZŐLŐS</span>
										</Link>
                  </MDBCol>
                </MDBRow>
              </MDBContainer>
					</div>
				</MDBContainer>


        <MDBContainer fluid className="fluid-container">
					<div className={styles.bodywrapper2}>
						<MDBRow className="m-0">
              <MDBCol size="12" className="p-0">
                <MDBRow className="pt-2 pb-5 m-0">
                  <MDBCol middle size="12" className="text-center">
                    <span className="tisztesseg-elszants text-uppercase">Tisztesség. Elszántság. Együttműködés.</span>
                  </MDBCol>
                </MDBRow>
                <MDBRow className="m-0">
                  <MDBCol size="12" className="text-center pb-4">
                    <img className="icon-landing-size" src={kepviselo}></img>
                  </MDBCol>
                  <MDBCol size="12" className="text-center">
                    <p className="kampany-title-respo">Jelenleg is Önt képviselem</p>
                    <span className="kampany-text-respo">a megyei közgyűlésben, az ellenzéki frakciót vezetem. Az Európai Unió Régiók Bizottságának munkájában magyar delegáltként környezetvédelemmel foglalkozom.</span>
                  </MDBCol>
                </MDBRow>
                <MDBRow className="m-0">
                  <MDBCol size="12" className="text-center py-4">
                    <img className="icon-landing-size" src={jogasz}></img>
                  </MDBCol>
                  <MDBCol size="12" className="text-center">
                    <p className="kampany-title-respo">Jogászként és közgazdászként</p>
                    <span className="kampany-text-respo">nemzetközi vállalatoknál szereztem tapasztalatot a mobiltelefon-iparban, az autóiparban és a telekommunikációban.</span>
                  </MDBCol>
                </MDBRow>
                <MDBRow className="m-0">
                  <MDBCol size="12" className="text-center py-4">
                    <img className="icon-landing-size" src={csalad}></img>
                  </MDBCol>
                  <MDBCol size="12" className="text-center pb-4">
                    <p className="kampany-title-respo-last">Kisgyermekes apaként</p>
                    <span className="kampany-text-respo">Vértesszőlősön élek családommal. Komárom-Esztergom megye születésem óta az otthonom.</span>
                  </MDBCol>
                </MDBRow>
              </MDBCol>
            </MDBRow>
					</div>
				</MDBContainer>

				<MDBContainer fluid className="fluid-container">
				<a id="program"/>
					<div className={styles.bodywrapper4}>
						<MDBRow className="m-0">
							<MDBCol size="12" className="p-0">
								<MDBRow className="m-0">
								<img className="asset1-size" src={asset1}></img>
								</MDBRow>
								<MDBRow className="m-0">
								<MDBCol size="12" middle className="text-center pb-2 pt-2">
									<Link to="/MindannyiunkHangja">
										<MDBBtn
												className="programok-btn-landing"
												type="btn"
												>
												 MINDANNYIUNK HANGJA
										</MDBBtn>
									</Link>
								</MDBCol>
								</MDBRow>
								<MDBRow center className="m-0">
								<MDBCol size="12" middle className="text-center pb-2 pt-2">
									<Link to="/OktatasMunkaVilaga">
										<MDBBtn
												className="programok-btn-landing"
												type="btn"
												>
												AZ OKTATÁS ÉS MUNKA VILÁGA
										</MDBBtn>
									</Link>
								</MDBCol>
								</MDBRow>
								<MDBRow center className="m-0">
								<MDBCol size="12" middle className="text-center pb-2 pt-2">
									<Link to="/Kozegeszsegugy">
										<MDBBtn
												className="programok-btn-landing"
												type="btn"
												>
												A KÖZEGÉSZSÉGÜGY MEGGYÓGYÍTÁSA
										</MDBBtn>
									</Link>
								</MDBCol>
								</MDBRow>
								<MDBRow center className="m-0">
									<MDBCol size="12" middle className="text-center pb-2 pt-2">
										<Link to="/LakhatasLakasfenntartas">
											<MDBBtn
													className="programok-btn-landing"
													type="btn"
													>
													LAKHATÁS, LAKÁSFENNTARTÁS
											</MDBBtn>
										</Link>
									</MDBCol>
								</MDBRow>
								<MDBRow center className="m-0">
									<MDBCol size="12" middle className="text-center pb-2 pt-2">
										<Link to="/KornyezetunkMegovasa">
											<MDBBtn
													className="programok-btn-landing"
													type="btn"
													>
													KÖRNYEZETÜNK MEGÓVÁSA
											</MDBBtn>
										</Link>
									</MDBCol>
								</MDBRow>
								<MDBRow className="m-0">
								<MDBCol size="12" middle className="text-center pb-2 pt-2">
									<Link to="/EpitettTermeszetiOrokseg">
										<MDBBtn
												className="programok-btn-landing"
												type="btn"
												>
												ÉPÍTETT ÉS TERMÉSZETI ÖRÖKSÉG
										</MDBBtn>
									</Link>
								</MDBCol>
								</MDBRow>
								<MDBRow center className="m-0">
								<MDBCol size="12" middle className="text-center pb-2 pt-2">
									<Link to="/KozlekedesiAnomaliak">
										<MDBBtn
												className="programok-btn-landing"
												type="btn"
												>
												A KÖZLEKEDÉSI ANOMÁLIÁK FELOLDÁSA
										</MDBBtn>
									</Link>
								</MDBCol>
								</MDBRow>
								<MDBRow center className="m-0">
								<MDBCol size="12" middle className="text-center pb-2 pt-2">
									<Link to="/PenzugyiForrasok">
										<MDBBtn
												className="programok-btn-landing"
												type="btn"
												>
												A PÉNZÜGYI FORRÁSOKRÓL
										</MDBBtn>
									</Link>
								</MDBCol>
								</MDBRow>
								<MDBRow center className="m-0">
									<MDBCol size="12" middle className="text-center pb-4 pt-2">
										<Link to="/MeltoIdoskor">
											<MDBBtn
													className="programok-btn-landing"
													type="btn"
													>
													MÉLTÓ IDŐSKORT
											</MDBBtn>
										</Link>
									</MDBCol>
								</MDBRow>
								<MDBRow center className="pb-5 m-0">
								 <span className="kisgyermekes-apaken">“Kisgyermekes apaként európai, fenntartható jövőt akarok nemcsak magunknak, hanem gyermekeinknek is. Itthon képzeljék el jövőjüket, lehessenek ismét büszkék hazánkra, és bizakodással tekinthessenek a jövőbe!”</span>
								</MDBRow>
							</MDBCol>
						</MDBRow>
					</div>
				</MDBContainer>

        <MDBContainer fluid className="section fluid-container">
          <div className={styles.bodywrapper3}>
            <MDBRow className="m-0">
              <MDBCol size="12" className="p-0">
                <MDBRow className="m-0">
                  <img className="asset2-size" src={asset2}></img>
                </MDBRow>
                <MDBRow className="m-0">
                  <MDBCol size="12" className="p-0 text-center">
                    <a href="https://www.facebook.com/drkonczererik" target="_blank" rel="noopener noreferrer">
                      <MDBRow start className="m-0">
                        <MDBCol middle size="5" className="pr-2 py-4 text-right">
                          <img className="social-icon" src={facebook}></img>
                        </MDBCol>
                        <MDBCol middle size="7" className="pl-2-0 py-4 text-left">
                          <span className="social-text">drkonczererik</span>
                        </MDBCol>
                      </MDBRow>
                    </a>
                    <a href="https://www.instagram.com/konczererik/" target="_blank" rel="noopener noreferrer">
                      <MDBRow start className="m-0">
                        <MDBCol middle size="5" className="pr-2 py-4 text-right">
                          <img className="social-icon" src={instagram}></img>
                        </MDBCol>
                        <MDBCol middle size="7" className="pl-2 py-4 text-left">
                          <span className="social-text">@konczererik</span>
                        </MDBCol>
                      </MDBRow>
                    </a>
                    <a href="https://twitter.com/erikkonczer" target="_blank" rel="noopener noreferrer">
                      <MDBRow start className="m-0">
                        <MDBCol middle size="5" className="pr-2 py-4 text-right">
                          <img className="social-icon" src={twitter}></img>
                        </MDBCol>
                        <MDBCol middle size="7" className="pl-2 py-4 text-left">
                          <span className="social-text">@erikkonczer</span>
                        </MDBCol>
                      </MDBRow>
                    </a>
                  {/*  <a href="" target="_blank" rel="noopener noreferrer">
                      <MDBRow start className="m-0">
                        <MDBCol middle size="5" className="pr-2 py-4 text-right">
                          <img className="social-icon" src={tiktok}></img>
                        </MDBCol>
                        <MDBCol middle size="7" className="pl-2 py-4 text-left">
                          <span className="social-text">@konczererik</span>
                        </MDBCol>
                      </MDBRow>
                    </a>*/}
                  </MDBCol>
                </MDBRow>
              </MDBCol>
              <MDBCol middle size="12" className="py-4 text-center" >

							{ browserName === "Safari" || browserName === "Mobile Safari" ?
								<FacebookProvider appId="932783620829084">
									<Page href="https://www.facebook.com/drkonczererik" tabs="timeline" />
								</FacebookProvider>
							:
							<iframe src={"https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com/%2Fdrkonczererik&tabs=timeline&width=" + parseInt(window.outerWidth*0.9) + "&height=450&small_header=true&adapt_container_width=true&hide_cover=true&show_facepile=false&appId"}
											width={parseInt(window.outerWidth*0.9) < 500 ?  parseInt(window.outerWidth*0.9) : 500}
											height="450"
											style={{border: "none",overflow: "hidden"}}
											scrolling="no"
											frameborder="0"
											allowfullscreen="true"
											allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
							}

              </MDBCol>
						</MDBRow>
							<FooterResponziv/>
          </div>
        </MDBContainer>
			</>
    );
  }
}
export default  LandingPageResponziv;
